import $ from 'jquery';
import slick from 'slick-carousel';
import * as CONST from '../../common/utils/constants';
import Util from '../../common/utils/ui'; 

class Testimonial {
    constructor(target, settings) {
        
    }

    init() {
        this.testimonialSlider();
    }

    testimonialSlider() {
        let $slickElement = $('.testimonial-list');

        $slickElement.on('init reInit afterChange', (event, slick, currentSlide) => {
            if (currentSlide === undefined) {
                currentSlide = 0;
            }

            $('.js-count').text(`${currentSlide + 1} of ${slick.slideCount}`);
        });

        if ($slickElement.length) {
            $slickElement.slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
                arrows: true,
                adaptiveHeight: true,
                prevArrow: $('.testimonial-prev'),
                nextArrow: $('.testimonial-next')
            });
        }
    }
}

export default Testimonial;

$(() => {
	const testimonial = new Testimonial();
	testimonial.init();
});